import { Reveal, Eyebrow } from "../Reveal";

export default function Legacy({ stats }) {
  return (
    <section data-testid="legacy-section" className="relative bg-ink text-cream py-24 md:py-32 overflow-hidden">
      <span className="absolute -top-10 right-0 font-display italic text-[16rem] leading-none text-white/[0.03] select-none pointer-events-none" aria-hidden="true">
        2011
      </span>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <Reveal>
          <Eyebrow>The House That Weddings Built</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl max-w-3xl leading-tight">
            A Legacy of Timeless Celebrations
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-cream/60 leading-relaxed">
            Founded in Mumbai in 2011, The Brides of India was the country's first wedding media house, and it remains
            its largest. From palace lawns to private islands, our lens has followed the Indian wedding across every
            continent the diaspora calls home.
          </p>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-16">
          {(stats || []).map((s, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <div className="bg-ink p-8 md:p-10 h-full" data-testid={`legacy-stat-${i}`}>
                <p className="font-display text-5xl md:text-6xl text-champagne">{s.value}</p>
                <p className="mt-3 text-[10px] md:text-xs uppercase tracking-[0.25em] text-cream/50">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
